<template>
   <nav class="navbar navbar-expand-lg navbar-light fixed-top">
        <a class="navbar-brand" href="/"><img src="../assets/logo.png"></a>
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav">
        <span class="navbar-toggler-icon"></span>
        </button>

        <div class="collapse navbar-collapse" id="navbarNav">
            <ul class="navbar-nav mr-auto">
                <li class="nav-item">
                    <router-link class="nav-link" data-toggle="collapse" data-target="#navbarNav" to="nature">Nature</router-link>
                </li>
                <li class="nav-item">
                   <router-link class="nav-link" data-toggle="collapse" data-target="#navbarNav" to="girls_indoor">Girls Indoor</router-link>
                </li>
                <li class="nav-item">
                   <router-link id="specialIndex" class="nav-link" data-toggle="collapse" data-target="#navbarNav" to="girls_outdoor">Girls Outdoor</router-link>
                </li>
                <li class="nav-item">
                   <router-link class="nav-link" data-toggle="collapse" data-target="#navbarNav" to="nude">Nude</router-link>
                </li>
                <li class="nav-item">
                   <router-link class="nav-link" data-toggle="collapse" data-target="#navbarNav" to="about">About me</router-link>
                </li>
            </ul>
        </div>
    </nav>
</template>

<script>
import $ from 'jquery';
export default {
  name: 'navbar',

  data () {
    return {
    }
  }
}

$( document ).ready(function() {
    if(window.location.pathname=="/"){
        $("#specialIndex").focus();
    }
});



   
</script>

<style lang="scss" scoped>
body{
    color:black !important;
}
nav{
    a{
        img{
            max-width:225px;
        }
        @media (max-width: 992px) {
            img{
                max-width:300px;
            }
        }
        @media (max-width: 860px) {
            img{
                max-width:250px;
            }
        }
        @media (max-width: 430px) {
            img{
                max-width:225px;
            }
        }
        @media (max-width: 389px) {
            img{
                max-width:200px;
            }
        }
        @media (max-width: 364px) {
            img{
                max-width:150px;
            }
        }
        @media (max-width: 315px) {
            img{
                max-width:125px;
            }
        }
        @media (max-width: 290px) {
            img{
                max-width:75px;
            }
        }
        
    }
}

</style>



// WEBPACK FOOTER //
// src/components/navbar.vue